import { contains, map } from 'ramda';
import React, { FC, useCallback } from 'react';
import { useMMGRSettings } from '../../../../utils/hoc/withMMGRSettings';
import { SourceItem } from './SourceItem';
import styles from './Sources.scss';
import { IOuter } from './Sources.types';
import { validateAdditionalSources } from '../../hooks/useSourceState';

export const Sources: FC<IOuter> = ({
  selectedSource,
  connectedSources,
  permanentSources,
  onSourceChange,
  onDisconnectClick,
}) => {
  const { mmgrSettings } = useMMGRSettings();
  const { externalSources } = mmgrSettings;
  const sources = validateAdditionalSources(externalSources, mmgrSettings);

  const isSourceConnected = useCallback((source) => contains(source, connectedSources), [connectedSources]);
  const isSourcePermanent = useCallback((source) => contains(source, permanentSources), [permanentSources]);

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {map(
          (source) => (
            <SourceItem
              key={source}
              source={source}
              selectedSource={selectedSource}
              sourceClassName={styles.source}
              isPermanent={isSourcePermanent(source)}
              isConnected={isSourceConnected(source)}
              onSourceChange={onSourceChange}
              onDisconnectClick={onDisconnectClick}
            />
          ),
          sources,
        )}
      </ul>
      <div className={styles.underlay} />
    </div>
  );
};
